import React, { Component } from "react";
import "./Login.css";
import { Auth } from "aws-amplify";
import LoaderButton from "../components/LoaderButton";


export default class ForgotPassword extends Component {

  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      errorMsg: "",
      resetCodeSent: false,
      email: ""
    };
  }

  validateForgotPasswordForm(){
    return this.state.email.length > 0;
  }

  validateResetPasswordForm(){
    return this.state.email.length > 0 && this.state.password
            && this.state.resetCode & this.state.resetCode.length > 0
            && this.state.password.length > 0 && this.state.retypePassword
            && this.state.password === this.state.retypePassword;

  }

  handleChange = event =>{

    this.setState({
       [event.target.id] : event.target.value,
       errorMsg: ""
    });
  }


  forgotPassword = async event => {
    event.preventDefault();
    this.setState( { isLoading: true, errorMsg: "" } );

    try{
      var retVal = await Auth.forgotPassword(this.state.email);
      this.setState({isLoading: false});
      this.setState({resetCodeSent: true});

    } catch(e){
      if(e.message === "Username/client id combination not found."){
          this.setState( {isLoading: false, errorMsg: "We did not find an account with this Email Id. Please Sign Up."} );
      }else{
         this.setState( {isLoading: false, errorMsg: e.message} );
      }

    }
  }

  resetPassword = async event => {
    event.preventDefault();
    if(!this.state.resetCode || this.state.resetCode.length === 0){
      this.setState({errorMsg: "Please enter the Reset Code sent to your email id"});
      return;
    }

    if(!this.state.password || this.state.password.length < 8){
      this.setState({errorMsg: "Password should be minimum 8 characters."});
      return;
    }

    if(this.state.retypePassword !== this.state.password){
      this.setState({errorMsg: "Password and Retype Password DO NOT Match."});
      return;
    }

    this.setState( { isLoading: true, errorMsg: "" } );

    try{
      var retVal = await Auth.forgotPasswordSubmit(this.state.email,
                                                   this.state.resetCode,
                                                   this.state.password);
      this.props.history.push("/login");

    } catch(e){
      this.setState( {isLoading: false, errorMsg: e.message} );
    }
  }

  getErrorElement(){
     return this.state.errorMsg && this.state.errorMsg.length > 0
                             ? <div className="alert alert-danger" role="alert">
                                 {this.state.errorMsg}
                               </div>
                             : "";
  }

  renderForgotPasswordForm(){
    return(
      <div className="loginContainer">
            <div className="login-header retnet-yrsa-font">
                <h4>FORGOT PASSWORD</h4>
            </div>
          {this.getErrorElement()}
          <form className="form-default" role="form" onSubmit={this.forgotPassword} >
              <div className="row">
                  <div className="col-12">
                      <div className="form-group">

                          <input type="email" id="email"
                             value={this.state.email}
                             onChange={this.handleChange}
                             placeholder="Please enter your Email Id"
                             className="form-control form-control-lg rounded" />
                      </div>
                  </div>
              </div>

              <LoaderButton block bsSize="large"
                           disabled = {!this.validateForgotPasswordForm()}
                           type="submit"
                           isLoading={this.state.isLoading}
                           text="Get Code"
                           loadingText="Logging in..."
                           className="btn btn-lg btn-block btn-success rounded retnet-16-font-size retnet-bold-font"/>


          </form>
      </div>
    );
  }

  renderForgotPasswordFormOld(){
        return(
          <section className="slice-lg has-bg-cover bg-size-cover loginpagebg" >
            <div className="container">
                <div className="row justify-content-center cols-xs-space">
                    <div className="col-lg-4">
                        <div className="form-card form-card--style-2 z-depth-2-top">
                            <div className="form-header text-center">
                                <div className="form-header-icon">
                                        <img src="/images/logo_retnetindia.png" />

                                </div>
                            </div>
                            <div className="form-body">
                                <div className="text-center px-2">
                                    <h4 className="heading heading-4 strong-400 mb-4">Forgot Password</h4>
                                </div>

                                <form className="form-default" role="form" onSubmit={this.forgotPassword} >
                                    <div className="row">
                                        <div className="col-12">
                                            <div className="form-group">
                                                <label>Email</label>
                                                <input type="email" id="email"
                                                   value={this.state.email}
                                                   onChange={this.handleChange}
                                                   className="form-control form-control-lg" />
                                            </div>
                                        </div>
                                    </div>

                                    <LoaderButton block bsSize="large"
                                                 disabled = {!this.validateForgotPasswordForm()}
                                                 type="submit"
                                                 isLoading={this.state.isLoading}
                                                 text="Get Code"
                                                 loadingText="Logging in..."
                                                 className="btn btn-styled btn-lg btn-block btn-info mt-4"/>
                                      <br />

                                </form>
                                {this.getErrorElement()}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
          </section>
        )
  }

  renderResetPasswordForm(){
    return(
      <div className="loginContainer">
            <div className="login-header retnet-yrsa-font">
                <h4>RESET YOUR PASSWORD</h4>
            </div>
          {this.getErrorElement()}
          <form className="form-default" role="form" onSubmit={this.resetPassword} >
              <div className="row">
                  <div className="col-12">
                      <div className="form-group">

                          <input type="email" id="email"
                             value={this.state.email}
                             onChange={this.handleChange}
                             placeholder="Please enter your Email Id"
                             className="form-control form-control-lg rounded" />
                      </div>
                  </div>
              </div>

              <div className="row">
                  <div className="col-lg-12">
                      <div className="form-group has-feedback">
                          <input type="text"
                                id="resetCode"
                                onChange={this.handleChange}
                                placeholder="Reset Code (Sent to your email id)"
                           className="form-control form-control-lg rounded" />
                      </div>
                  </div>
              </div>

              <div className="row">
                  <div className="col-lg-12">
                      <div className="form-group has-feedback">
                          <input type="password"
                                id="password"
                                onChange={this.handleChange}
                                placeholder="New Password"
                           className="form-control form-control-lg rounded" />
                      </div>
                  </div>
              </div>

              <div className="row">
                  <div className="col-lg-12">
                      <div className="form-group has-feedback">
                          <input type="password"
                                id="retypePassword"
                                onChange={this.handleChange}
                                placeholder="Retype New Password"
                           className="form-control form-control-lg rounded" />
                      </div>
                  </div>
              </div>

              <LoaderButton block bsSize="large"
                           disabled = {!this.validateResetPasswordForm()}
                           type="submit"
                           isLoading={this.state.isLoading}
                           text="Reset Password"
                           loadingText="Resetting Password..."
                           className="btn btn-lg btn-block btn-success rounded retnet-16-font-size retnet-bold-font"/>
          </form>
      </div>
    );
  }

  renderResetPasswordFormOld(){
      return(
        <section className="slice-lg has-bg-cover bg-size-cover loginpagebg" >
          <div className="container">
              <div className="row justify-content-center cols-xs-space">
                  <div className="col-lg-4">
                      <div className="form-card form-card--style-2 z-depth-2-top">
                          <div className="form-header text-center">
                              <div className="form-header-icon">
                                      <img src="/images/logo_retnetindia.png" />

                              </div>
                          </div>
                          <div className="form-body">
                              <div className="text-center px-2">
                                  <h4 className="heading heading-4 strong-400 mb-4">Reset Password</h4>
                              </div>

                              <form className="form-default" role="form" onSubmit={this.resetPassword} >
                                  <div className="row">
                                      <div className="col-12">
                                          <div className="form-group">
                                              <label>Email</label>
                                              <input type="email" id="email"
                                                 value={this.state.email}
                                                 onChange={this.handleChange}
                                                 className="form-control form-control-lg" />
                                          </div>
                                      </div>
                                  </div>

                                  <div className="row">
                                      <div className="col-12">
                                          <div className="form-group">
                                              <label>Reset Code (sent to your email)</label>
                                              <input type="text" id="resetCode"
                                                 onChange={this.handleChange}
                                                 className="form-control form-control-lg" />
                                          </div>
                                      </div>
                                  </div>

                                  <div className="row">
                                      <div className="col-lg-12">
                                          <div className="form-group has-feedback">
                                              <label>New Password</label>
                                              <input type="password"
                                                    id="password"
                                                    onChange={this.handleChange}
                                               className="form-control form-control-lg" />
                                          </div>
                                      </div>
                                  </div>

                                  <div className="row">
                                      <div className="col-lg-12">
                                          <div className="form-group has-feedback">
                                              <label>Retype New Password</label>
                                              <input type="password"
                                                    id="retypePassword"
                                                    onChange={this.handleChange}
                                               className="form-control form-control-lg" />
                                          </div>
                                      </div>
                                  </div>


                                  <LoaderButton block bsSize="large"
                                               disabled = {!this.validateResetPasswordForm()}
                                               type="submit"
                                               isLoading={this.state.isLoading}
                                               text="Reset Password"
                                               loadingText="Resetting Password..."
                                               className="btn btn-styled btn-lg btn-block btn-info mt-4"/>

                              </form>
                              {this.getErrorElement()}
                          </div>
                      </div>
                  </div>
              </div>
          </div>
        </section>
      )
  }

  render(){

      return this.state.resetCodeSent ? this.renderResetPasswordForm()
                                      : this.renderForgotPasswordForm();




  }

}



// WEBPACK FOOTER //
// ./src/containers/ForgotPassword.js